// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import 'jquery'
import axios from 'axios'
import {encryption} from './assets/js/encryption.js' // 请求必需携带公共头部
import VueTouch from 'vue-touch'
import scroll from 'vue-seamless-scroll' // 引用无缝滚动插件
import VueWechatTitle from 'vue-wechat-title' // 引用每个页面title修改插件
import MyopenJesongChat from '../config/chat'
Vue.use(VueTouch, {name: 'v-touch'})
VueTouch.config.swipe = {
  threshold: 100 // 手指左右滑动距离
}
Vue.config.productionTip = false
Vue.prototype.$axios = axios
Vue.prototype.$encryption = encryption
Vue.prototype.$easyliao = MyopenJesongChat
Vue.use(scroll)
Vue.use(VueWechatTitle)
router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
// 访问不同页面，回滚到顶部
router.afterEach((to, from, next) => {
  window.scrollTo(0, 0)
})
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  axios,
  encryption,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js